<template>
    <div id="jbandApp">
        <!-- Preloader -->
        <transition name="fade">
            <div class="jband-loader" v-if="loading">
                <div class="loader-inner">
                    <svg viewBox="0 0 309.2 108.69" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="m74.59 0h18.16v54.34a54.31 54.31 0 0 1 -92.75 38.41l12.84-12.84a36.16 36.16 0 0 0 61.75-25.57zm-36.18 86.89a32.47 32.47 0 0 1 -23-9.54l12.83-12.84a14.38 14.38 0 0 0 24.55-10.17v-54.34h18.21v54.34a32.59 32.59 0 0 1 -32.59 32.55m253.38-30.69c0 9.94-6.77 15.57-17.06 15.57h-9.14v-31.4h9.14c10.29 0 17.06 5.81 17.06 15.65zm-119.08 6.33 6.95-17.41 6.86 17.41zm-35.34 5c0 3.61-2.91 5.63-8.18 5.63h-13.19v-11.33h13c5.72 0 8.36 2.2 8.36 5.54zm-21.37-28.48h11.17c5 0 7.73 1.85 7.73 5.28v.18c0 3.6-3 5.36-8.17 5.36h-10.73zm158.56-13.71h-25.86v32.53l-25.32-32.53h-15.92v45.58l-19.26-45.58h-16.82l-17.27 41c-1.15-6.13-5.53-9.52-11.91-11.62 5.45-2.38 9.5-6.6 9.5-13.72v-.18a13.85 13.85 0 0 0 -4-10c-3.6-3.52-9.05-5.45-16.79-5.45h-31.53v61.52h31.74c6.61 0 12-1.31 15.89-3.7l-1.56 3.7h17.85l4.4-11.08h23.83l4.39 11.08h28.43v-33.77l26.38 33.77h23.47c22.08 0 35-13.19 35-30.95v-.18c0-17.76-12.75-30.42-34.64-30.42m-169.38-20.67h1.14a1.26 1.26 0 0 1 .81.24 1 1 0 0 1 .28.75 1 1 0 0 1 -.28.75 1.17 1.17 0 0 1 -.81.27h-1.14zm0 3.29h1.2l.94 1.75h1.85l-1.34-2.07a1.82 1.82 0 0 0 .85-.79 2.59 2.59 0 0 0 .32-1.25 2 2 0 0 0 -.72-1.6 2.94 2.94 0 0 0 -2-.58h-2.75v6.29h1.61zm-3.49-3.73a5.13 5.13 0 0 1 1.85-1.88 5.19 5.19 0 0 1 5.19 0 5.1 5.1 0 0 1 1.86 1.86 5 5 0 0 1 .67 2.56 5 5 0 0 1 -.68 2.57 5.19 5.19 0 0 1 -1.87 1.88 5 5 0 0 1 -2.61.69 5 5 0 0 1 -2.58-.68 5.05 5.05 0 0 1 -1.84-1.86 5.12 5.12 0 0 1 -.68-2.57 5.06 5.06 0 0 1 .68-2.57m1 8.41a6.45 6.45 0 0 0 3.4.92 6.57 6.57 0 0 0 3.43-.93 6.8 6.8 0 0 0 2.49-2.49 6.66 6.66 0 0 0 .9-3.38 6.67 6.67 0 0 0 -.9-3.39 6.62 6.62 0 0 0 -2.46-2.46 6.78 6.78 0 0 0 -6.82 0 6.78 6.78 0 0 0 -2.44 2.49 6.66 6.66 0 0 0 -.9 3.38 6.77 6.77 0 0 0 3.32 5.84"
                            fill="#fff"
                        />
                    </svg>
                    <h2 v-html="loadingText"></h2>
                </div>
            </div>
        </transition>

        <div class="jband-container">
            <transition name="fade">
                <selection-view :project-data="projectData" :selected-project="selectedProject" v-on:selectProject="onSelectProject" v-on:selectionUpdated="onSelectionUpdated" v-if="projectData">
                </selection-view>
            </transition>

            <!-- Error Message -->
            <transition name="fade">
                <div class="jband-error" v-if="error">
                    <div class="error-inner">
                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="m15.516 14.016h-.797l-.281-.281q.75-.844 1.148-1.945t.398-2.273q0-1.359-.492-2.531t-1.383-2.063-2.086-1.406-2.508-.516q-1.734 0-3.164.797t-2.32 2.156-.984 3.047h2.016q.094-1.125.727-2.039t1.594-1.43 2.133-.516q1.219 0 2.25.609t1.641 1.617.609 2.273q0 1.219-.609 2.25t-1.641 1.641-2.25.609q-.141 0-.258-.023t-.258-.023v2.016h.516q1.172 0 2.273-.398t1.945-1.148l.281.281v.797l4.969 4.969 1.5-1.5zm-9.047-3.188-2.484 2.484-2.438-2.484-.75.703 2.484 2.484-2.484 2.438.75.75 2.438-2.484 2.484 2.484.703-.75-2.484-2.438 2.484-2.484z"
                                fill="#fff"
                            />
                        </svg>
                        <h2 v-html="errorText"></h2>
                    </div>
                </div>
            </transition>

            <transition name="fade">
                <map-view
                    :current-selection="currentSelection"
                    :selected-project="selectedProject"
                    v-on:selectProject="onSelectProject"
                    v-on:selectionUpdated="onSelectionUpdated"
                    v-on:showErrorMessage="onShowErrorMessage"
                    v-if="currentSelection"
                >
                </map-view>
            </transition>
        </div>
    </div>
</template>

<script>
import MapView from './components/MapView.vue';
import SelectionView from './components/SelectionView.vue';

import axios from 'axios';
import gsap from 'gsap';
import { setTimeout } from 'timers';

export default {
    name: 'jbandApp',
    components: { MapView, SelectionView },

    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            assetUrl: process.env.VUE_APP_ASSET_URL,
            projectData: null,
            partialProjectData: null,
            totalProjectData: 0,
            totalYearData: 0,
            currentProjectData: 0,
            currentYearData: 0,
            currentSelection: null,
            selectedProject: null,
            loading: true,
            error: false,
            loadingText: "<span style='color:#fff;'>Loading Projects</span>",
            errorText: "<span style='color:#fff;'>No Results</span>"
        };
    },

    methods: {
        showError(errorText) {
            console.log(error);
            this.loadingText = "<span style='color:#ff3a1e;'>" + errorText + '</span>';
        },

        fetchData() {
            axios
                .get(this.assetUrl + 'data/projects-v3.json')
                .then((response) => {
                    // Apply initial project data
                    this.partialProjectData = response.data;

                    // Set total values of projects AND nested years
                    this.totalProjectData = this.partialProjectData.products.length;
                    this.totalYearData = this.partialProjectData.products[this.currentProjectData].projects.length;

                    // Start loading
                    this.fetchProjectsByYear(this.partialProjectData.products[this.currentProjectData].projects[this.currentYearData].path);
                })
                .catch((error) => {
                    this.showError('Cannot Load Projects');
                })
                .finally(() => {});
        },

        fetchProjectsByYear(dataUrl) {
            console.log(dataUrl);
            axios
                .get(this.assetUrl + 'data/' + dataUrl)
                .then((response) => {
                    // Apply loaded value to current locations prop
                    this.partialProjectData.products[this.currentProjectData].projects[this.currentYearData].locations = response.data.locations;

                    // Check to make sure all years for current project have been loaded
                    if (this.currentYearData < this.totalYearData - 1) {
                        // Increment year and load next
                        this.currentYearData++;
                        this.fetchProjectsByYear(this.partialProjectData.products[this.currentProjectData].projects[this.currentYearData].path);
                    } else {
                        console.log('done loading current project years');
                        // Reset current year being loaded
                        this.currentYearData = 0;

                        // Check to make sure all projects have been loaded
                        if (this.currentProjectData < this.totalProjectData - 1) {
                            // Increment project and load next
                            this.currentProjectData++;
                            // Reset total year value and load next
                            this.totalYearData = this.partialProjectData.products[this.currentProjectData].projects.length;
                            this.fetchProjectsByYear(this.partialProjectData.products[this.currentProjectData].projects[this.currentYearData].path);
                        } else {
                            console.log('done loading projects');

                            this.projectData = this.partialProjectData;

                            // Smooth out the transiton a bit.
                            setTimeout(() => {
                                this.loading = false;
                            }, 1000);
                        }
                    }
                })
                .catch((error) => {
                    this.showError('Cannot Load Projects');
                })
                .finally(() => {});
        },

        onSelectionUpdated(payload) {
            this.currentSelection = payload;
        },

        onSelectProject(payload) {
            this.selectedProject = payload;
        },

        onShowErrorMessage(payload) {
            this.error = payload;
        }
    },

    mounted() {
        TweenLite.set(this.$el, {
            autoAlpha: 0
        });

        TweenLite.to(this.$el, 0.5, {
            autoAlpha: 1.0,
            delay: 1.0,
            ease: Sine.easeOut,
            force3D: true,
            onComplete: () => {
                // Fade in a preloader and fetch data
                this.fetchData();
            }
        });
    }
};
</script>

<style scoped lang="scss">
#jbandApp {
    font-family: 'Montserrat', sans-serif;
    font-weight: 300; // 300,500,600
    // Font smoothing
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
    height: 740px;

    @media screen and (min-width: 768px) {
        height: 830px;
    }

    @media screen and (min-width: 1024px) {
        height: 900px;
    }

    .jband-loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3000;
        background-color: #1f1f1f;

        .loader-inner {
            opacity: 1;
            animation: flickerAnimation 1.5s ease-in-out infinite;
            text-align: center;

            h2 {
                text-transform: uppercase;
                font-size: 16px * 0.8;
                font-weight: 600;
                margin: 0;
                color: #fff;

                @media screen and (min-width: 768px) {
                    font-size: 16px * 0.9;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 16px;
                }
            }

            svg {
                margin: 0 auto 5px auto;
                width: 130px;
                height: auto;

                @media screen and (min-width: 768px) {
                    width: 150px;
                }

                @media screen and (min-width: 1024px) {
                    width: 170px;
                }
            }
        }
    }

    .jband-error {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        background-color: rgba(#1f1f1f, 0.75);
        width: 100%;
        height: 100%;

        @media screen and (min-width: 768px) {
            width: calc(100% - 340px * 0.9);
            left: calc(340px * 0.9);
        }

        @media screen and (min-width: 1024px) {
            width: calc(100% - 340px);
            left: 340px;
        }

        .error-inner {
            opacity: 1;
            animation: flickerAnimation 1.5s ease-in-out infinite;
            text-align: center;

            h2 {
                text-transform: uppercase;
                font-size: 16px * 0.8;
                font-weight: 600;
                margin: 0;
                color: #fff;

                @media screen and (min-width: 768px) {
                    font-size: 16px * 0.9;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 16px;
                }
            }

            svg {
                margin: 0 auto -5px auto;
                width: 130px * 0.5;
                height: auto;
                padding-left: 10px;

                @media screen and (min-width: 768px) {
                    width: 150px * 0.5;
                }

                @media screen and (min-width: 1024px) {
                    width: 170px * 0.5;
                }
            }
        }
    }

    .jband-container {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #2d2d2d;

        @media screen and (min-width: 768px) {
            display: flex;
        }
    }
}

.fade-enter-active {
    transition: all 0.5s ease 0s;
}
.fade-leave-active {
    transition: all 0.5s ease 0s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@keyframes flickerAnimation {
    /* flame pulses */
    0% {
        opacity: 1;
    }
    66% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
</style>
